import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { openModalAction } from '../../../../actions/modal';
import TableWithLocalPagination from '../../../../containers/Table/TableWithLocalPagination';
import { Column } from '../../../../containers/Table/TableWithPagination';
import Strings from '../../../../Strings';
import { actions } from '../../redux/actions';

function GroupOrganizations(props) {
  const { groupDetails, groupUsers, onRefresh, openConfirmModal } = props;

  const removeOrgFromGrp = (_, org) => {
    const data = {
      title: Strings.deleteOrgFromGroupWarningarning(org.name, groupDetails.name),

      onConfirmAction: actions.editOrganizationGroup(
        groupDetails.id,
        {
          ...groupDetails,
          organizations: groupDetails.organizations.filter(o => o.id !== org.id).map(o => o.id),
          maintainers: groupDetails.maintainers.map(o => o.id),
        },
      ),
      onSuccessNotification: Strings.formatString(Strings.itemSaved, groupDetails.name),
      confirmPostAction: onRefresh,
    };
    openConfirmModal(data);
  };

  return (
    <TableWithLocalPagination
      name="organizations-in-group"
      data={groupDetails?.organizations || []}
      buttons={(groupDetails?.role === 'owner' || groupDetails?.role === 'maintainer') ? [
        {
          icon: 'delete',
          onClick: removeOrgFromGrp,
          text: Strings.delete,
          disabled: (_, org) => {return groupDetails.maintainers?.some(m => m.org_uuid === org.id) || groupUsers?.some(u => u.org_uuid === org.id)},
          disabledTooltip: Strings.cantDeleteOrgFromGroup,
        }] : undefined}
      infiniteScroll
      columns={[
        <Column key="name" title={Strings.name} value={d => d.name} />,
        <Column key="id" title={Strings.id} value={d => d.id} />,
      ]}
    />
  );
}

const mapDispatchToProps = dispatch => ({
  openConfirmModal: data => dispatch(openModalAction('confirmation-modal', data)),
});

GroupOrganizations.propTypes = {
  groupDetails: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    organizations: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })).isRequired,
    maintainers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      org_uuid: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  groupUsers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    org_uuid: PropTypes.string,
  })).isRequired,
  onRefresh: PropTypes.func.isRequired,
  openConfirmModal: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(GroupOrganizations);
